import React from "react";

interface PaveBalanceIconProps {
  className?: string;
}

const PaveBalanceIcon: React.FC<PaveBalanceIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M246.725 433.232L77.0085 263.49C72.8722 259.354 72.8722 252.645 77.0085 248.508L246.725 78.7663C250.862 74.63 257.57 74.63 261.707 78.7663L300.372 117.431C304.508 121.568 304.508 128.276 300.372 132.413L184.276 248.508C180.14 252.645 180.14 259.354 184.276 263.49L300.372 379.585C304.508 383.722 304.508 390.431 300.372 394.567L261.707 433.232C257.57 437.368 250.862 437.368 246.725 433.232Z"
        fill="#1E1E2E"
      />
      <path
        d="M340.821 344.438L308.588 312.205C305.132 308.749 305.132 303.15 308.588 299.72L346.067 262.24C349.522 258.785 349.522 253.186 346.067 249.756L308.588 212.276C305.132 208.821 305.132 203.222 308.588 199.792L340.821 167.558C344.276 164.103 349.875 164.103 353.306 167.558L435.503 249.756C438.958 253.211 438.958 258.81 435.503 262.24L353.306 344.438C349.85 347.893 344.251 347.893 340.821 344.438Z"
        fill="#FF4E17"
      />
    </svg>
  );
};

export default PaveBalanceIcon;
